import { useQuery } from '@apollo/client';
import { OndemandVideo } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';
import { AuditLogList } from '~/components/AuditLogs';
import { RouterBreadcrumbs } from '~/components/RouterBreadcrumbs';
import { ScrollableRouterTabs } from '~/components/RouterTabs';
import { PageContainer } from '~/components/page-layout';
import { Toolbar } from '~/components/toolbar';
import { useAppContext } from '~/contexts';
import { useLink } from '~/hooks/link';
import { NetworkChannelAuditLogsDocument } from '../queries/AuditLogs.generated';
import { useTabs } from './lib/tabs';

export const ChannelAuditLogs = () => {
  const { t } = useTranslation();
  const params = useParams<{ channelId: string }>();
  const channelId = parseInt(params.channelId ?? '');

  const { currentNetwork } = useAppContext();
  const link = useLink();

  const tabs = useTabs();

  const { data, loading } = useQuery(NetworkChannelAuditLogsDocument, {
    variables: { networkId: currentNetwork.id, channelId },
  });

  const channel = data?.network?.channel;

  if (loading || !channel) return !loading ? <Navigate to={link('/not-found')} replace /> : null;

  return (
    <>
      <Toolbar
        breadcrumbsLabel={<RouterBreadcrumbs />}
        titleIcon={<OndemandVideo />}
        titleText={channel.name}
      />

      <ScrollableRouterTabs current={t('common.tabs.audit_logs')} tabs={tabs} />

      <PageContainer>
        <AuditLogList recordTypes={['Channel']} channelId={channelId} />
      </PageContainer>
    </>
  );
};
